import React from "react";
import PropTypes from "prop-types";

import "./confirmation_popup.less";

import Popup from "@ui/popup";
import StatefulButton from "@ui/stateful_button";

const ConfirmationPopup = ({
  cancelButtonLabel,
  children,
  confirmButtonLabel,
  onCancel,
  onConfirm,
  ...otherProps
}) => (
  <Popup
    className="ConfirmationPopup"
    footer={
      <>
        <StatefulButton onClick={onConfirm}>
          {confirmButtonLabel}
        </StatefulButton>
        {cancelButtonLabel && (
          <button type="button" onClick={onCancel}>
            {cancelButtonLabel}
          </button>
        )}
      </>
    }
    onClose={onCancel}
    {...otherProps}
  >
    {children}
  </Popup>
);

ConfirmationPopup.propTypes = {
  cancelButtonLabel: PropTypes.node,
  children: PropTypes.node,
  confirmButtonLabel: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

ConfirmationPopup.defaultProps = {
  cancelButtonLabel: "Cancel",
  confirmButtonLabel: "Confirm"
};

export default ConfirmationPopup;
